import React from 'react';
import { Link } from 'gatsby';
import searchStyles from '../../pages/search.module.scss';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import { useBibSearchResultStateSetters } from '../../hooks/useBibSearchResultStateSetters';
import DocumentFuncButtons from '../DocumentFuncButtons/DocumentFuncButtons';
import ItemsTable from '../ElementList/ElementListRecords/ItemsTable/ItemsTable';
import ConnectedRecords from '../ElementList/ElementListRecords/ConnectedRecords/ConnectedRecords';
import { connectedRecordTypeBasedOnPeriodicLevel } from '../../constants/common';
import RecordConnectionController from '../RecordConnectionController/RecordConnectionController';
import { documentTypes } from '../../constants/documentTypes';
import moment from 'moment/moment';
import DocumentsTable from '../ElementList/ElementListRecords/DocumentsTable/DocumentsTable';
import { controlledFeatures } from '../../utils/featureControl';

const ListElement = props => {
  const {
    allDoctypeMappingCsv,
    node,
    selectedRecords = [],
    me,
    setReservationData,
    setRequestData,
    parentGuids = [],
    periodicalType,
  } = props;
  const {
    setBibSearchResultStateProperties,
  } = useBibSearchResultStateSetters();

  const cover = node?.publicFiles?.find(
    file => file.classification === 'cover'
  );

  const matchCurrentElement =
    allDoctypeMappingCsv.nodes.find(node => node.hun === node.type) ??
    allDoctypeMappingCsv.nodes.find(node => node.key === 'else');

  const resolveTypeFromCsv = rawType => {
    const find = allDoctypeMappingCsv.nodes.find(node => node.key === rawType);

    if (!find)
      return (
        documentTypes.find(type => type.value === rawType)?.displayName ||
        rawType
      );
    return find.hun;
  };

  const getOnlyYear = date => {
    const momentDate = moment(date);

    if (momentDate.isValid()) {
      return momentDate.format('YYYY');
    } else {
      return date;
    }

    // let resp = '';
    // for (let i = 0; i < date.length; i++) {
    //   if (Number.isInteger(parseInt(date[i]))) resp += date[i];
    //   if (resp.length >= 4) break;
    // }
    // return resp;
  };

  const documents =
    node?.publicFiles?.filter(file => file.classification === 'service') ?? [];

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12}>
          <Link
            to={`/elements/${node.guid}/${node.guid}`}
            className={searchStyles.searchSingleItemLink}
            // state={{ fromElements: props.path + props.location.search }}
          >
            <Grid
              container
              xs={12}
              wrap="nowrap"
              className={searchStyles.searchSingleItemHead}
            >
              <Grid item xs={2}>
                <div style={{ textAlign: 'center', marginBottom: '.5rem' }}>
                  <img
                    src={cover?.publicUrl ?? matchCurrentElement.svg}
                    alt={matchCurrentElement.hun}
                    style={{
                      maxHeight: '60%',
                      maxWidth: '60%',
                    }}
                  />
                </div>
                <div style={{ textAlign: 'center' }}>
                  {resolveTypeFromCsv(node.type)}
                </div>
              </Grid>
              <Grid
                item
                className={searchStyles.searchSingleItemContentContainer}
              >
                <div className={searchStyles.searchSingleItemContent}>
                  <div className={searchStyles.searchSingleItemTitle}>
                    <span>{node.title}</span>
                  </div>
                  {/* <div className={searchStyles.searchSingleItemTitle}>
                <span>{resolveTypeFromCsv(node.type)}</span>
              </div> */}
                  <div className={searchStyles.searchSingleItemAuthor}>
                    <span>{node.author}</span>
                  </div>
                  <div className={searchStyles.searchSingleItemAppearance}>
                    <span>
                      {node.placeOfAppearance
                        ? `${node.placeOfAppearance}, `
                        : ''}{' '}
                    </span>
                    <span style={{ fontWeight: 700 }}>
                      {node.publisher ? `${node.publisher}, ` : ''}{' '}
                    </span>
                    <span>
                      {node.releaseDate ? getOnlyYear(node.releaseDate) : ''}
                    </span>
                  </div>
                  <div className={searchStyles.searchSingleItemSource}></div>
                </div>
              </Grid>
            </Grid>
          </Link>
        </Grid>
        <Grid item className={searchStyles.searchSingleItemCheckbox}>
          <Checkbox
            color="primary"
            checked={selectedRecords.includes(node.guid)}
            value={selectedRecords.includes(node.guid)}
            onChange={e => {
              if (e.target.checked) {
                setBibSearchResultStateProperties({
                  selectedRecords: [...selectedRecords, node.guid],
                });
                return null;
              }

              setBibSearchResultStateProperties({
                selectedRecords: selectedRecords.filter(
                  selectedRecordId => node.guid !== selectedRecordId
                ),
              });
            }}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        className={searchStyles.functionContainer}
      >
        <Grid
          item
          className={searchStyles.searchSingleItemImgContainerSpacer}
        />
        <Grid item className={searchStyles.functionContainerButtons}>
          <DocumentFuncButtons
            url={`/elements/${node.guid}/${node.guid}`}
            data1={node.rawMarcRecord}
          />
        </Grid>
      </Grid>
      {// lehet ide kelleni fog majd új feature control változó
      controlledFeatures.itemList && (
        <div
          className={searchStyles.instanceData}
          style={{ marginBottom: '10px' }}
        >
          <DocumentsTable documents={documents} count={documents.length} />
        </div>
      )}
      {controlledFeatures.itemList && (
        <div className={searchStyles.instanceData}>
          <ItemsTable
            bibId={node.guid}
            bib={node}
            me={me}
            setReservationData={setReservationData}
            setRequestData={setRequestData}
            count={node?.itemCount}
            items={node?.items}
            periodicalType={periodicalType}
          />
          {/* <HoldingsTable data={node.items} count={node.itemsCount} fromElementsList /> */}
        </div>
      )}
      <RecordConnectionController
        rawMarcRecord={node?.rawMarcRecord}
        parentGuids={parentGuids}
      >
        {({ uniqConnectedBibIds, parentGuids }) =>
          connectedRecordTypeBasedOnPeriodicLevel.map(x => (
            <div
              className={searchStyles.instanceData}
              style={{ marginTop: '10px' }}
            >
              <ConnectedRecords
                connectedBibIds={uniqConnectedBibIds}
                parentGuids={[...parentGuids, node.guid]}
                periodicalLevels={x.levels}
                name={x.name}
                periodicalType={x.type}
              />
            </div>
          ))
        }
      </RecordConnectionController>
    </React.Fragment>
  );
};

export default ListElement;
